import { Injectable } from '@angular/core'
import { ICultureIndexSurveyInvitedNotification } from '@candidate/app/models/app-notification.model'
import { INotificationHandler, INotificationView, UserAppNotificationService } from '@engineering11/notifications-web'
import { CandidateHomeNavigationService } from '../candidate-home-navigation.service'

@Injectable({ providedIn: 'root' })
export class CultureIndexInvitationNotificationHandler implements INotificationHandler<ICultureIndexSurveyInvitedNotification, INotificationView> {
  notificationType = 'cultureindex_culture_index_survey_sent'
  constructor(
    private candidateHomeNavigationService: CandidateHomeNavigationService,
    private userAppNotificationService: UserAppNotificationService
  ) {}

  async onClick(notification: ICultureIndexSurveyInvitedNotification): Promise<boolean> {
    if (!notification.viewed) {
      await this.userAppNotificationService.markNotificationAsRead(notification.id)
    }
    return this.candidateHomeNavigationService.toCultureIndexSurvey(notification.jobPostId)
  }
}
